import Table from "@/components/AdvanceTable"
import {getContractList,deleteContract,muldel,exportall} from "@/api/contract.js"
import {getAll} from "@/api/workplace.js"
import {getSearchParm,columns,excelheader} from "./data.js"
import {message} from "ant-design-vue"
import downloadexcel from "vue-json-excel";
import Detial from '@/components/Detial/index.vue'

let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)


export default {
   components:{
	  Table,
	  downloadexcel,
	  Detial,
   }, 
   data(){
       let {name,yi,yiPhone,yiWorkPlace} = this.$route.query
	   let dd1 = localStorage.getItem("date1"),dd2=localStorage.getItem("date2")
        return{
			detialId:-1,
			detialshow:false,
            columns,
			excelheader,
            request:{
                "get":getContractList,
                "delet":deleteContract,
                "delets":muldel,
            },
			workplaceArray:[],
            searchData:getSearchParm({
                name:name||"",
                yi:yi||"",
                yiPhone:yiPhone||"",
                yiWorkPlace:yiWorkPlace||"",
				tt1:dd1,
				tt2:dd2
            }),
            formData:{
            },
        }
   },
   methods:{
	godetial(record){
		let {id} = record
		this.detialId = id
		this.detialshow = true
	},
	backdetial(){
		this.detialshow = false
	},
	   getWorkPlaceArray(){
		   getAll({cmpid:user.cmpid}).then(ret=>{
			  if(ret.code == 0) {
				  let {data} = ret
				  this.workplaceArray = data
			  }
		   })
	   },
	   workplacechange(v,e){
		   let {data:{attrs:{text}}} = e
		   this.searchData = {...this.searchData,yiWorkPlace:text}
	   },
		getdataSource(){
			message.loading({content:"正在导出",key:"daochu"})
			let data = this.$refs.tableref.getDataSource()
			return data
		},
		exportsuccess(){
			message.success({content:"导出成功",key:"daochu",duration:2})
		},
		async getAllData(){
			message.loading({content:"正在导出",key:"daochu"})
			let parm = this.$refs.tableref.getsearchparm()
			let {code,data} = await exportall(parm)
			if(code == 0){
				return data
			}
			return false
		},
		Update(record,showModal){
            this.formData = {...record}
            showModal("修改")
        },
        Delete(record,showDelConfirm){
            this.formData = {...record}
            showDelConfirm()
        },
		getTotalMoney(data){
			let {rows,pricesum} = data,pagesum = 0
			if(rows&&pricesum){
				pagesum = rows.reduce((total,item)=>{
					total += (parseFloat(item.price)||0)
					return total
				},0)
			}
			return {pagesum,pricesum}
		}
   },
   mounted(){
	   this.getWorkPlaceArray()
   }
}

